import { Injectable, Type } from "@angular/core";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmCoupon } from "@natiwi/shared/models/coupon.model";

export class NatCouponRepository extends NatCatalogRepository<OrmCoupon> {

    constructor(adapter?: NatRestAdapter) {
        super(adapter);
        let repoUrl: string = '/coupons';
        let repoModel: Type<OrmCoupon> = OrmCoupon;
        this.init(repoUrl, repoModel);
    }
}